import { Loader } from '@components/loader';
import { Merchants } from '@pages/merchants';
import { useListMerchants } from '@services/staff/merchants/list';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { config } from './-filtersConfig';

function MerchantList() {
  const navigate = useNavigate();
  const { localId } = useParams({ from: '/u/$localId/_staff/staff/merchants/' });
  const { data, isPending } = useListMerchants();

  if (isPending) return <Loader />;

  return (
    <Merchants
      data={data}
      filtersConfig={config}
      onRowSelect={(merchant) => {
        navigate({
          to: '/u/$localId/staff/merchants/$merchantId/orders',
          params: { merchantId: merchant.merchantId, localId },
        }).catch((err) => console.error(err));
      }}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/merchants/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['merchants_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: MerchantList,
});
